import { render, staticRenderFns } from "./NotificationFormImage.vue?vue&type=template&id=66eb9517&scoped=true&"
import script from "./NotificationFormImage.vue?vue&type=script&lang=js&"
export * from "./NotificationFormImage.vue?vue&type=script&lang=js&"
import style0 from "./NotificationFormImage.vue?vue&type=style&index=0&id=66eb9517&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66eb9517",
  null
  
)

export default component.exports